import { Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { TrainingProgress } from '@/hooks/use-training-progress';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDate } from '@/lib/format';


interface RecentActivityProps {
  progress: TrainingProgress | undefined;
}

export function RecentActivity({ progress }: RecentActivityProps) {
  if (!progress) return null;

  const completedModules = progress.modules
    .filter((m) => m.status === 'completed' && m.completed_at)
    .sort((a, b) => new Date(b.completed_at!).getTime() - new Date(a.completed_at!).getTime());

  const lastCompleted = completedModules[0];

  if (!lastCompleted) return null;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Clock className="h-4 w-4" />
          Recent Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">Last completed: {lastCompleted.title}</p>
            <p className="text-xs text-muted-foreground">
              {formatDate(lastCompleted.completed_at!)}
            </p>
          </div>
          <Link
            to={`/training/modules/${lastCompleted.module_id}`}
            className="text-sm text-primary hover:underline"
          >
            Review
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
